import {
  ErrorText,
  FormItemChildren,
  FormItemLabel,
  FormItemRoot,
} from './styles';

import Icon from '@components/Icon';
import { Row } from '@components/LinearLayout';
import { useTranslation } from 'react-i18next';

interface FormItemProps {
  children?: JSX.Element | JSX.Element[];
  label?: string | JSX.Element;
  hint?: string | JSX.Element;
  labelColor?: string;
  labelFontSize?: string;
  width?: string;
  required?: boolean;
  error?: string;
  isLocked?: boolean;
  isEditable?: boolean;
  isCentered?: boolean;
  paddingLabel?: string;
  gap?: string;
  isSmallForm?: boolean;
}
const FormItem = ({
  children,
  label,
  hint,
  labelColor,
  labelFontSize,
  width,
  required = false,
  error,
  isLocked,
  isEditable,
  isCentered,
  isSmallForm,
  paddingLabel = '0 0 0 1rem',
  gap = '0.5rem',
}: FormItemProps) => {
  const { t } = useTranslation();
  return (
    <FormItemRoot $width={width} $isLocked={isLocked} $gap={gap}>
      {label && (
        <Row $gap="1rem">
          <FormItemLabel
            $required={required}
            $isCentered={isCentered}
            $paddingLabel={paddingLabel}
            $labelColor={labelColor}
            $isSmallForm={isSmallForm}
            $labelFontSize={labelFontSize}
          >
            {label}
          </FormItemLabel>
          {isLocked && <Icon name="lock" color={labelColor} />}
        </Row>
      )}

      {children && (
        <FormItemChildren isLocked={isLocked}>{children}</FormItemChildren>
      )}
      {error && <ErrorText>{t(error)}</ErrorText>}
    </FormItemRoot>
  );
};

export default FormItem;
